import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, inject } from 'vue';

import Instagram3Images from './Instagram3Images.vue';
import InstagramFullWidth from './InstagramFullWidth.vue';
import InstagramHighlight from './InstagramHighlight.vue';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'Instagram',
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const product = inject('product', null);

const blockVariant = computed(() => {
  switch (props.block?.fields?.InstagramBlockVariant?.value) {
    case '3images':
      return Instagram3Images;
    case 'fullwidth':
      return InstagramFullWidth;
    case 'highlight':
      return InstagramHighlight;
    default:
      return null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(blockVariant))
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(blockVariant)), {
        key: 0,
        block: props.block,
        product: _unref(product)
      }, null, 8, ["block", "product"]))
    : _createCommentVNode("", true)
}
}

})